module.exports = __webpack_public_path__ + "static/media/trip-m3@2x.7a922cd8.png";